export default {"src":"/_next/static/media/youtube-play.fcf5eeeb.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};